// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@guestsupply/Overrides/Widgets/Basic/LinkList";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {
    css: css`
        text-transform: uppercase;
        padding: 10px 0;
    `,
};

linkListStyles.titleWrapper = {
    css: css`
        font-weight: bold;
    `,
};

linkListStyles.titleLink = {
    color: "text",
    typographyProps: {
        size: 16,
        lineHeight: "19px",
    },
};
linkListStyles.title = {
    color: "primary.contrast",
    as: "span",
    size: 16,
    lineHeight: "19px",
};

linkListStyles.linkWrapper = {
    css: css`
        margin-bottom: 12px;
        line-height: 15px;
        padding: 0;
    `,
};

linkListStyles.linkStyles = {
    color: "text",
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        transform: "initial",
    },
};
